module.exports = __webpack_public_path__ + "img/telekom-logo.2c0ac603.svg";